import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'wsb-fields-assocaitions-modal',
  templateUrl: './fields-assocaitions-modal.component.html',
  styleUrls: ['./fields-assocaitions-modal.component.scss'],
  standalone: false
})
export class FieldsAssociationsModalComponent implements OnInit {
  @Input() fields: any[];
  @Input() columnToContactFields: Array<any>;
  @Input() isFieldEdit = false;

  @Output() columnToContactFieldsEmitter: EventEmitter<any> = new EventEmitter();
  @Output() cancelFileUpload: EventEmitter<any> = new EventEmitter();

  fieldsMapping = new Array();

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    const alpha = Array.from(Array(26)).map((e, i) => i + 65);
    const alphabet = alpha.map(x => String.fromCharCode(x));
    this.fieldsMapping.push({
      label: 'Ignore field',
      id: -1
    });
    let index = 0;
    alphabet.forEach(letter => {
      this.fieldsMapping.push({
        label: letter,
        id: index++
      });
    });

    if (!this.columnToContactFields) {
      this.columnToContactFields = new Array();
      this.fields.forEach(field => {
        this.columnToContactFields.push({
          idField: field,
          column: -1,
          label: 'Ignore field'
        });
      });
    }
  }

  buildColumnToContactFields(field, selected) {
    const index = this.columnToContactFields.findIndex(x => x.idField === field.idField);
    this.columnToContactFields[index].label = selected.label;
    this.columnToContactFields[index].column = selected.id;
    this.columnToContactFieldsEmitter.emit(this.columnToContactFields);
  }

  fileModalDismiss() {
    if (this.isFieldEdit) {
      this.activeModal.dismiss();
    } else {
      // this.cancelFileUpload.emit(true);
      this.activeModal.dismiss();
    }
  }
}
